import React from 'react';
const NoChatSVG = ({ className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='139'
      height='131'
      viewBox='0 0 139 131'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <circle cx='66.7772' cy='69.9107' r='59.0955' fill='#E6F3FD' />
      <path
        d='M85.5651 36.8452C104.233 36.8452 119.292 50.4216 119.292 67.1119C119.292 76.7026 114.314 85.2969 106.473 90.9018V103.482C106.473 105.226 104.482 106.097 103.237 105.101L92.5345 96.7559C90.2943 97.1295 88.0542 97.3786 85.6896 97.3786C67.0217 97.3786 51.9629 83.8022 51.9629 67.1119C51.9629 50.4216 67.0217 36.8452 85.5651 36.8452Z'
        fill='#B9DBFA'
        stroke='#8CC2F6'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M52.5857 35.3506C31.8021 35.3506 15.001 50.4217 15.001 68.9803C15.001 79.6919 20.6014 89.2826 29.313 95.3858V109.336C29.313 111.204 31.4287 112.325 32.9222 111.08L44.8696 101.863C47.3587 102.361 49.8477 102.61 52.4613 102.61C73.2449 102.61 90.046 87.5389 90.046 68.9803C90.046 50.4217 73.2449 35.3506 52.5857 35.3506Z'
        fill='white'
        stroke='#B9DBFA'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M40.3276 70.3505C42.5958 70.3505 44.4346 68.5102 44.4346 66.2402C44.4346 63.9701 42.5958 62.1299 40.3276 62.1299C38.0594 62.1299 36.2207 63.9701 36.2207 66.2402C36.2207 68.5102 38.0594 70.3505 40.3276 70.3505Z'
        fill='#8CC2F6'
      />
      <path
        d='M63.5982 70.3505C65.8664 70.3505 67.7051 68.5102 67.7051 66.2402C67.7051 63.9701 65.8664 62.1299 63.5982 62.1299C61.33 62.1299 59.4912 63.9701 59.4912 66.2402C59.4912 68.5102 61.33 70.3505 63.5982 70.3505Z'
        fill='#8CC2F6'
      />
      <path
        d='M57.1294 83.4288C56.7561 83.4288 56.3827 83.3042 56.1338 82.9306C55.1382 81.5605 53.6448 80.8131 51.9024 80.8131C50.2845 80.8131 48.6667 81.5605 47.7955 82.9306C47.4221 83.5533 46.6754 83.6779 46.0531 83.1797C45.4309 82.806 45.3064 82.0587 45.8042 81.4359C47.1732 79.443 49.5378 78.1975 52.0269 78.1975C54.5159 78.1975 56.7561 79.443 58.2495 81.4359C58.6229 82.0587 58.4984 82.806 58.0006 83.1797C57.6273 83.4288 57.3783 83.4288 57.1294 83.4288Z'
        fill='#8CC2F6'
      />
      <path
        d='M43.3262 32.1895C43.1762 32.1895 43.0261 32.1895 42.876 32.1895C42.1257 31.8891 41.6756 31.1382 41.8256 30.3873L44.3766 22.1274C44.6767 21.3765 45.427 20.926 46.1773 21.0761C46.9276 21.3765 47.3778 22.1274 47.2277 22.8783L44.8268 31.1382C44.6767 31.739 44.0765 32.1895 43.3262 32.1895Z'
        fill='#8CC2F6'
      />
      <path
        d='M37.0244 33.9917C36.4242 33.9917 35.824 33.5412 35.5238 32.9405L31.6223 21.0762C31.3222 20.3253 31.7724 19.4242 32.5227 19.1239C33.273 18.8235 34.1733 19.274 34.4734 20.025L38.3749 31.8892C38.6751 32.6401 38.2249 33.5412 37.4746 33.8416C37.3245 33.9918 37.1745 33.9917 37.0244 33.9917Z'
        fill='#8CC2F6'
      />
      <path
        d='M31.1735 36.8452C30.7234 36.8452 30.4232 36.6951 30.1231 36.3947L25.3213 31.7391C24.721 31.1384 24.721 30.2373 25.3213 29.6366C25.9215 29.0359 26.8218 29.0359 27.4221 29.6366L32.2239 34.2922C32.8242 34.8929 32.8242 35.794 32.2239 36.3947C31.9238 36.6951 31.4737 36.8452 31.1735 36.8452Z'
        fill='#8CC2F6'
      />
      <circle cx='27.704' cy='13.7338' r='3.70399' fill='#E6F3FD' />
      <circle cx='108.868' cy='6.93268' r='6.9029' fill='#E6F3FD' />
      <circle cx='12.8677' cy='9.93268' r='6.9029' fill='#E6F3FD' />
      <circle cx='6.56617' cy='107.961' r='6.56617' fill='#E6F3FD' />
      <circle cx='130.083' cy='101.563' r='6.56617' fill='#E6F3FD' />
      <circle cx='117.287' cy='108.971' r='3.1989' fill='#E6F3FD' />
      <path
        d='M133.167 81.3025L134.198 86.174L139 87.2201L134.198 88.2663L133.167 93.1378L132.136 88.2663L127.334 87.2201L132.136 86.174L133.167 81.3025Z'
        fill='white'
      />
      <path
        d='M126.796 32.5346C126.918 31.9569 127.742 31.9569 127.865 32.5346L128.288 34.535C128.333 34.7453 128.496 34.91 128.706 34.9558L130.713 35.3928C131.286 35.5177 131.286 36.3357 130.713 36.4606L128.706 36.8976C128.496 36.9434 128.333 37.108 128.288 37.3184L127.865 39.3188C127.742 39.8965 126.918 39.8965 126.796 39.3188L126.372 37.3184C126.328 37.108 126.164 36.9434 125.954 36.8976L123.948 36.4606C123.374 36.3357 123.374 35.5177 123.948 35.3928L125.954 34.9558C126.164 34.91 126.328 34.7453 126.372 34.535L126.796 32.5346Z'
        fill='#8CC2F6'
      />
      <path
        d='M20.5217 116.278C20.6439 115.7 21.4685 115.7 21.5908 116.278L22.4832 120.494C22.5277 120.704 22.6914 120.869 22.9015 120.915L27.0914 121.827C27.6648 121.952 27.6649 122.77 27.0914 122.895L22.9015 123.808C22.6914 123.854 22.5277 124.018 22.4832 124.229L21.5908 128.445C21.4685 129.022 20.6439 129.022 20.5217 128.445L19.6293 124.229C19.5848 124.018 19.421 123.854 19.211 123.808L15.0211 122.895C14.4476 122.77 14.4476 121.952 15.0211 121.827L19.211 120.915C19.421 120.869 19.5848 120.704 19.6293 120.494L20.5217 116.278Z'
        fill='#8CC2F6'
      />
      <path
        d='M10.3799 25.0373C10.0631 24.9699 10.0631 24.5178 10.3799 24.4504L12.7292 23.9508C12.8446 23.9263 12.9349 23.8363 12.96 23.721L13.4672 21.3817C13.5356 21.0665 13.9852 21.0665 14.0536 21.3817L14.5608 23.721C14.5858 23.8363 14.6762 23.9263 14.7916 23.9508L17.1409 24.4504C17.4577 24.5178 17.4577 24.9699 17.1409 25.0373L14.7916 25.5369C14.6762 25.5614 14.5858 25.6514 14.5608 25.7667L14.0536 28.1059C13.9852 28.4212 13.5356 28.4212 13.4672 28.1059L12.96 25.7667C12.9349 25.6514 12.8446 25.5614 12.7292 25.5369L10.3799 25.0373Z'
        fill='#8CC2F6'
      />
    </svg>
  );
};

export default NoChatSVG;
